module.exports = __webpack_public_path__ + "static/media/5.ce38fb74.png";